import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import MobileHeader from './MobileHeader'
import MobileBottomNavigation from './NavBar'
import OfflineIndicator from '../common/OfflineIndicator'

const ResponsiveLayout = () => {
  const location = useLocation()
  // Hide bottom nav on specific chat thread, but show it on conversations list
  const isChatThread = location.pathname.startsWith('/chat/')

  return (
    <div 
      className="fixed inset-0 bg-gray-100 flex justify-center overflow-hidden"
      style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
    >
      <div className="w-full max-w-md bg-white shadow-2xl flex flex-col h-full border-x border-gray-200">
        <OfflineIndicator />
        <MobileHeader />
        
        <div className="flex-1 overflow-hidden" key={location.pathname}>
          <Outlet />
        </div>
        
        {!isChatThread && <MobileBottomNavigation />}
      </div>
    </div>
  )
}

export default ResponsiveLayout